import { AppstoreAddOutlined } from '@ant-design/icons';

import { EmptyState } from 'app/components/pages/Extranet/commons/EmptyState/EmptyState';

import styles from '../../PackagesRoomsAmenities.module.scss';

import type { EntitySectionConfig, RenderItem } from './entity';

type Props<T> = {
  section: EntitySectionConfig<T>;
  renderItem: RenderItem<T>;
  emptyLabel?: string;
  emptyDescription?: string;
  showEmptyState?: boolean;
};

export const EntitySection = <T,>({
  section,
  renderItem,
  emptyLabel,
  emptyDescription,
  showEmptyState = true,
}: Props<T>) => (
  <div className={styles.section}>
    {section.label && (
      <div className={styles.sectionTitle}>{section.label}</div>
    )}

    {section.items.length === 0 && showEmptyState ? (
      <EmptyState
        title={emptyLabel ?? 'No items'}
        description={emptyDescription}
        icon={<AppstoreAddOutlined />}
      />
    ) : (
      section.items.map((item, index) => renderItem(item, index))
    )}
  </div>
);
